import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  gdsDelProcessFetchGdsDelProcess: null,
  gdsDelProcessFetchGdsDelProcessLoading: ['boolean'],
  gdsDelProcessFetchGdsDelProcessSuccess: ['process']
});

export const GdsDelProcessTypes = Types;
export default Creators;
